// extracted by mini-css-extract-plugin
export var container = "styles-module__container____fhPo";
export var controlBtns = "styles-module__controlBtns___WqEfD";
export var coordinates = "styles-module__coordinates___ZrOM2";
export var description = "styles-module__description___NYCmm";
export var linkBtn = "styles-module__linkBtn___iUWgV";
export var nameAndDescription = "styles-module__nameAndDescription___c3PpX";
export var title = "styles-module__title___aaDpf";